import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { BankInvestmentTransferValidationError } from '../../types'

export const BankInvestmentValidationCard: FC<{
  bankInvestmentValidationError: BankInvestmentTransferValidationError
}> = ({ bankInvestmentValidationError }) => {
  const { t } = useTranslation('features-transfer')

  // If the error is NA or BAD_REQUEST, don't show the card
  if (
    bankInvestmentValidationError === BankInvestmentTransferValidationError.NA ||
    bankInvestmentValidationError === BankInvestmentTransferValidationError.BAD_REQUEST
  )
    return null

  // WHEN AN ERROR IS RETURNED FROM THE API THIS SIGNIFIES THAT A DEPOSIT OR WITHDRAWAL IS ALREADY IN PROGRESS
  // BOTH AN INLINE ERROR IS SET ON TO FIELD AND THIS CARD WILL DISPLAY
  // USERS WILL RECEIVE A DEPOSIT IN PROGRESS MESSAGE WHEN ATTEMPTING TO WITHDRAW FUNDS FROM INVESTMENT ACCOUNT
  // USERS WILL RECEIVE A WITHDRAWAL IN PROGRESS MESSAGE WHEN ATTEMPTING TO DEPOSIT FUNDS INTO INVESTMENT ACCOUNT
  return (
    <div className="mb-8 flex w-full justify-center">
      <div className="flex flex-col items-start justify-between bg-sky-50 py-4 px-8 gap-3 w-full">
        <div className="col flex flex-col gap-1">
          <p className="text-sky-600 text-xs font-bold">
            {t(
              bankInvestmentValidationError === BankInvestmentTransferValidationError.WITHDRAWAL
                ? 'bank_investment_validation_error.deposit_card_title'
                : 'bank_investment_validation_error.withdrawal_card_title',
            )}
          </p>
          <p className="text-sm text-sky-700">
            {t(
              bankInvestmentValidationError === BankInvestmentTransferValidationError.WITHDRAWAL
                ? 'bank_investment_validation_error.deposit_card_description'
                : 'bank_investment_validation_error.withdrawal_card_description',
            )}
          </p>
        </div>
      </div>
    </div>
  )
}
